import React from 'react'
import { observer } from 'mobx-react'
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
} from 'components/Table/ClickableTable'
import BookkeepingManagerViewModel from 'admin/bookkeeping/BookkeepingManagerViewModel'
import InfiniteScrollLoader from 'components/InfiniteScrollLoader'
import BookkeepingManagerTableRow from '../BookkeepingManagerTableRow'
import ContentLoading from 'components/ContentLoading'
import ContentError from 'components/ContentError'

interface BookkeepingManagerTableProps {
  vm: BookkeepingManagerViewModel
}

export default observer(function BookkeepingManagerTable({
  vm,
}: BookkeepingManagerTableProps) {
  const columns = vm.columns

  return (
    <>
      {vm.searcher.scroller.fetch.match({
        pending: () => <ContentLoading />,
        rejected: (err) => <ContentError error={err} />,
        resolved: () => (
          <>
            <Table striped data-test="bookkeeping-manager-table">
              <TableHead>
                {columns.map((col) => (
                  <TableHeader
                    key={col.id}
                    canSort={col.sortable}
                    sortOrder={vm.getSortOrder(col)}
                    onSort={(newSort) => {
                      vm.setSortOrder(col, newSort)
                    }}
                  >
                    {col.header}
                  </TableHeader>
                ))}
              </TableHead>
              <TableBody>
                {vm.filteredItems.map((item) => (
                  <BookkeepingManagerTableRow
                    key={item.id}
                    vm={vm}
                    bookkeepingPendingAction={item}
                  />
                ))}
              </TableBody>
            </Table>
            <InfiniteScrollLoader scrollProvider={vm.searcher.scroller} />
          </>
        ),
      })}
    </>
  )
})
